module.exports = __webpack_public_path__ + "static/media/old_outcome_version_3.ad7e6156.png";